import styles from "./Footer.module.css";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

function Footer() {
  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerContent}>
        <div>
          <p className={styles.footerTitle}>Kontakt</p>
          <p>Oskar-Meixner-Str. 4, 68163 Mannheim</p>
          <p>
            <a href="tel:+4915787964401">+49 157 879 644 01</a>
          </p>
          <p>
            <a href="mailto:kontakt@foodosia.de">
              kontakt@foodosia.de
            </a>
          </p>
        </div>
        <div>
          <p className={styles.footerTitle}>Rechtliches</p>
          <ul>
            <li>
              <a href="/agb">AGB</a>
            </li>
            <li>
              <a href="/impressum">Impressum</a>
            </li>
            <li>
              <a href="/einwilligungen">Einwilligungen</a>
            </li>
            <li>
              <a href="/datenschutzerklaerung">Datenschutzerklärung</a>
            </li>
          </ul>
        </div>
        <div>
          <p className={styles.footerTitle}>Soziales</p>
          <a
            href="https://www.instagram.com/foodosia.catering?igsh=ZThqZjFnNmNqYzd5"
            target="_blank"
            rel="external"
          >
            Instagram
            <OpenInNewRoundedIcon id={styles.externalLinkIcon} />
          </a>
        </div>
      </div>
      <div className={styles.footerCopyright}>
        <p>© 2025 Foodosia. Alle Rechte vorbehalten</p>
      </div>
    </div>
  );
}

export default Footer;
